import { render, staticRenderFns } from "./templateMultiTag.vue?vue&type=template&id=cbacd3f6&scoped=true"
import script from "./templateMultiTag.vue?vue&type=script&lang=js"
export * from "./templateMultiTag.vue?vue&type=script&lang=js"
import style0 from "./templateMultiTag.vue?vue&type=style&index=0&id=cbacd3f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbacd3f6",
  null
  
)

export default component.exports